<template>
  <div :class="$style.feature_page">
    <MoleculesConsumerHeadingWithImage
      title="Feature"
      sub-title="特集一覧"
      image-src="/images/site/feature/features.jpeg"
      background-color="#eef2f7"
    />
    <div :class="$style.container">
      <PagesFeaturePickUpList id="list" :page="pickupItems" />
      <div :class="$style.divider" />
    </div>
    <div :class="$style.container">
      <PagesList id="list" :page="featureItems" />
      <MoleculesConsumerPager :class="$style.pager" :total-page="totalPageCount" scroll-id="list" />
    </div>
    <OrganismsCategories />
  </div>
</template>

<script setup lang="ts">
import { PageFragmentFragment } from "~/types/type.generated"
import { usePublicPageFindQuery, usePublicPageFindPopularQuery } from "~/gql/urql.generated"
import { useCustomMeta } from "~/composables/meta"
import { useToast } from "~/state"

definePageMeta({ layout: "default-with-extended-footer" })

const route = useRoute()
const customMeta = useCustomMeta()
const toast = useToast()

const perPage = 15
const page = computed(() => {
  return typeof route.query.page === "string" ? +route.query.page : 1
})

const variables = computed(() => {
  return {
    pageType: "feature",
    page: page.value,
    limit: perPage,
  }
})
const {
  data: resFeatureSearchQuery,
  error: featureSearchError,
  executeQuery,
} = await usePublicPageFindQuery({ variables })

const { data: resFeaturePickupQuery, error: featurePickupError } = await usePublicPageFindPopularQuery({
  variables: {
    filter: {
      is_status: true,
      feature_pickup: true,
    },
    limit: 2,
  },
})

const featureItems = computed<PageFragmentFragment[]>(() => {
  if (!resFeatureSearchQuery?.value?.publicPageFind?.items) return []
  return resFeatureSearchQuery.value.publicPageFind.items
})

const pickupItems = computed<PageFragmentFragment[]>(() => {
  if (!resFeaturePickupQuery?.value?.publicPageFindPopular) return []
  return resFeaturePickupQuery.value.publicPageFindPopular
})

const totalPageCount = computed(() => {
  return resFeatureSearchQuery?.value?.publicPageFind?.pageInfo?.pageCount || 1
})

watch(
  () => route.fullPath,
  async () => {
    await executeQuery({ requestPolicy: "network-only" })
  },
)

watch(
  () => featureSearchError.value,
  (value) => {
    if (!value) return
    toast?.showErrorToasted(value.message)
  },
)

watch(
  () => featurePickupError.value,
  (value) => {
    if (!value) return
    toast?.showErrorToasted(value.message)
  },
)

useHead(
  customMeta.fetch({
    title: "特集一覧",
    description: "TENTIAL特集ページの一覧です",
  }),
)
</script>

<style scoped module lang="scss">
.feature_page {
  .container {
    @include container-lg;
    margin-bottom: 3rem;
    .pager {
      justify-content: flex-end;
    }
  }
  .divider {
    height: 4px;
    width: 100%;
    background-color: $secondary-20;
    border-radius: 4px;
  }
}
</style>
